let API_BASE_URL;

if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = process.env.REACT_APP_ETRUCK_API_BASE_URL;
} else {
  API_BASE_URL = 'http://localhost:8000';
}

export const API_ENDPOINTS = {
    getOCParcelData: `${API_BASE_URL}/api/orange-county-parcels/`,
    getSCAQMDJurisdiction: `${API_BASE_URL}/api/scaqmd-jurisdiction/`,
    getMdhdInfrastructure: `${API_BASE_URL}/api/calstart-mdhd-infrastructure/`,
    getWarehouses: `${API_BASE_URL}/api/warehouses/`,
}